import script from "./marketplace_results_panel.vue?vue&type=script&setup=true&lang=js"
export * from "./marketplace_results_panel.vue?vue&type=script&setup=true&lang=js"

import "./marketplace_results_panel.vue?vue&type=style&index=0&id=0046c7d2&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0046c7d2"]])

export default __exports__